module.exports = __webpack_public_path__ + "img/sFwdH.7b4169cd.svg";